import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    carouselSelectedIndex: 0,
    selectedProduct: null,  // or an empty object if required
};

const productCarouselSlice = createSlice({
    name: 'productCarousel',
    initialState,
    reducers: {
        setProduct: (state, action) => {
            state.selectedProduct = action.payload;
        },
        setCarouselSelectedIndex: (state, action) => {
            state.carouselSelectedIndex = action.payload;
        },
    },
});

export const { setProduct, setCarouselSelectedIndex } = productCarouselSlice.actions;

export default productCarouselSlice.reducer;
